if(!customElements.get('modal-stock-notify')) {
  class ModalStockNotify extends ModalDialog {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.successWrapper = this.querySelector("[data-success-message]");
      this.errorWrapper = this.querySelector("[data-error-message]");
      this.form.addEventListener("submit", this.onSubmit.bind(this));
      this._initNotifyDropdown();
    }

    show(opener) {
      // Update notify me modal variant dropdown with currently selected variant
      const variantInput = this.form?.querySelector('[data-variant-input]');
      const variantDropdown = this.querySelector('[data-notify-dropdown]');
      if (variantInput && variantDropdown) {
        const currentVariantId = opener?.closest('form')?.querySelector('input[name="id"]')?.value;
        if (currentVariantId) {
          const currentVariantOption = this.querySelector(`[data-notify-dropdown-option][data-value="${currentVariantId}"]`);
          if (currentVariantOption) {
            variantDropdown.querySelectorAll('[data-notify-dropdown-option]').forEach((o) => o.setAttribute('aria-selected', o === currentVariantOption ? 'true' : 'false'));
            const visibleLabel = variantDropdown.querySelector('[data-notify-dropdown-value]');
            if (visibleLabel) visibleLabel.textContent = currentVariantOption.textContent.trim();
            variantInput.value = currentVariantId;
          }
        }
      }
      super.show(opener);
    }

    _initNotifyDropdown() {
      const dropdown = this.querySelector("[data-notify-dropdown]");
      if (!dropdown) return;

      const trigger = dropdown.querySelector("[data-notify-dropdown-trigger]");
      const listbox = dropdown.querySelector("[data-notify-dropdown-listbox]");
      const valueEl = dropdown.querySelector("[data-notify-dropdown-value]");
      const variantInput = this.form.querySelector("[data-variant-input]");
      const options = dropdown.querySelectorAll("[data-notify-dropdown-option]");

      const open = () => {
        dropdown.setAttribute("data-open", "true");
        trigger.setAttribute("aria-expanded", "true");
        listbox.removeAttribute("hidden");
        listbox.focus();
        const selected = listbox.querySelector('[aria-selected="true"]');
        if (selected) selected.focus();
        document.addEventListener("click", closeOnClickOutside);
        document.addEventListener("keydown", handleListboxKeydown);
      };

      const close = () => {
        dropdown.removeAttribute("data-open");
        trigger.setAttribute("aria-expanded", "false");
        listbox.setAttribute("hidden", "");
        trigger.focus();
        document.removeEventListener("click", closeOnClickOutside);
        document.removeEventListener("keydown", handleListboxKeydown);
      };

      const closeOnClickOutside = (e) => {
        if (dropdown.contains(e.target)) return;
        close();
      };

      const setSelection = (option) => {
        options.forEach((o) => o.setAttribute("aria-selected", "false"));
        option.setAttribute("aria-selected", "true");
        const value = option.getAttribute("data-value");
        const title = option.textContent.trim();
        if (variantInput) variantInput.value = value;
        if (valueEl) valueEl.textContent = title;
      };

      const handleListboxKeydown = (e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          close();
          return;
        }
        if (e.key !== "ArrowDown" && e.key !== "ArrowUp" && e.key !== "Enter" && e.key !== " ") return;
        if (e.target.getAttribute("role") !== "option") return;

        const current = e.target;
        const list = Array.from(options);
        const idx = list.indexOf(current);

        if (e.key === "ArrowDown" && idx < list.length - 1) {
          e.preventDefault();
          list[idx + 1].focus();
        } else if (e.key === "ArrowUp" && idx > 0) {
          e.preventDefault();
          list[idx - 1].focus();
        } else if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setSelection(current);
          close();
        }
      };

      trigger.addEventListener("click", () => {
        if (dropdown.getAttribute("data-open") === "true") close();
        else open();
      });

      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " " || e.key === "ArrowDown" || e.key === "ArrowUp") {
          e.preventDefault();
          if (dropdown.getAttribute("data-open") !== "true") open();
          else if (e.key === "ArrowDown" && options[0]) options[0].focus();
          else if (e.key === "ArrowUp" && options[options.length - 1]) options[options.length - 1].focus();
        }
      });

      listbox.addEventListener("keydown", handleListboxKeydown);

      options.forEach((opt) => {
        opt.addEventListener("click", () => {
          setSelection(opt);
          close();
        });
      });
    }

    onSubmit(e) {
      e.preventDefault();
      fetch(e.target.action, {
        method: e.target.method,
        headers: {
          accept: 'application/json',
          revision: '2024-06-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: e.target.querySelector('[name="email"]').value
                  }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${e.target.querySelector('[name="variant"]').value}`
                }
              }
            }
          }
        }),
      })
        .then((response) => {
          if(response.status === 202) {
            this.onSuccess(e.target.querySelector('[name="email"]').value);
          } else {
            this.onError('There was something wrong with your request: Enter a valid email address.');
          }
        })
        .catch((error) => {
          this.onError(error.message || error.description || error)
        }
      );
    }

    onSuccess(email) {
      this.successWrapper.textContent = email
        ? this.successWrapper.dataset.successMessage.replace("[email]", email)
        : "";
      this.successWrapper.classList.toggle("hidden", !email);
      this.onError(false);
    }

    onError(error) {
      this.errorWrapper.textContent = error || "";
      this.errorWrapper.classList.toggle("hidden", !error);
    }

    reset() {
      this.querySelector('input[name="email"]').value = '';
      this.onError(false);
      this.onSuccess(false);
      const dropdown = this.querySelector("[data-notify-dropdown]");
      if (dropdown) {
        const listbox = dropdown.querySelector("[data-notify-dropdown-listbox]");
        const valueEl = dropdown.querySelector("[data-notify-dropdown-value]");
        const variantInput = this.form.querySelector("[data-variant-input]");
        const firstOption = dropdown.querySelector("[data-notify-dropdown-option]");
        if (firstOption && listbox && valueEl && variantInput) {
          listbox.querySelectorAll("[data-notify-dropdown-option]").forEach((o) => o.setAttribute("aria-selected", "false"));
          firstOption.setAttribute("aria-selected", "true");
          valueEl.textContent = firstOption.textContent.trim();
          variantInput.value = firstOption.getAttribute("data-value");
        }
      }
    }

    hide() {
      super.hide();
      this.reset();
    }
  }

  customElements.define("modal-stock-notify", ModalStockNotify);
}